import React from 'react';
import styled from 'styled-components';

import AffiliationItem from './AffiliationItem';


const AffiliationListing = ({ listingData }) => {
    
    return (
        <div className={'grid-row'}>
            <ul className={'grid-col-12'}>
                {
                    listingData.map(listingItem => (
                        <AffiliationItem key={listingItem.partnerId} data={listingItem} />
                    ))
                }
            </ul>
        </div>
    );
};

export default AffiliationListing;